import { OnInit, Component, EventEmitter, Output, Input } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import * as moment from 'moment';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'app-informacion-contrato-component',
    templateUrl: './informacion-contrato.component.html',
    styleUrls: ['./../administrar-funcionarios.component.scss']
})
export class InformacionContratoComponent implements OnInit {

    @Input() datosFuncionario: AdministrarFuncionarioDTO;
    @Input() existeFuncionario: boolean;
    @Input() deshabilitado: boolean;
    @Input() dominios: DetalleDominio[];
    public documentoARL: string;
    public consultaCargo: any;
    public placeholderInicio: string;
    public placeholderFin: string;
    public rolUsuario: string;
    parametros: string[] = [DominiosService.TIEMPO_FIN_CONTRATO];
    opcSelect: string;

    constructor(
        private utilService: UtilService,
        private spinner: NgxSpinnerService,
        private global: GlobalService,
        private urlService: UrlService,
        private alertService: AlertService) {
            this.consultaCargo = [];
    }

    ngOnInit() {
        this.placeholderInicio = 'Seleccione fecha de vinculación';
        this.placeholderFin = 'Seleccione fecha fin de contrato';
        this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
        this.opcSelect=sessionStorage.getItem(ConstantesService.OPC_SELECT);

        this.obtenerCargo();

        if (this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH
            && !this.datosFuncionario.fechaFinVinculacion) {
            this.consultarParametros();
        }
    }

    private consultarParametros() {
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        this.global.postGenerico(url, this.parametros).subscribe(
            data => {
                if (data.length > 0) {
                    this.datosFuncionario.fechaFinVinculacion
                        = moment(new Date().setHours(0, 0, 0, 0)).add(Number(data[0].valor), 'months').toDate();
                }
            }, error => {
                this.alertService.generateAlertError('Se presentó un error al cargar los pámetros del correo', '');
            });
    }

    esSGA() {
        return this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_SGA;
    }

    /**
     * Consulta los tipo de Documento Existente
     */
    public obtenerCargo() {
        if(this.opcSelect === VariablesZonaCompartida.PATH_OPC_ADMIN_PERSONAL_TERCE 
            && this.rolUsuario != DominiosService.ROL_ADMINISTRADOR_TH ){
            this.consultaCargo = this.dominios.filter(dominio =>
                dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_CARGO_FUNCIONARIO
                && dominio.detalleDominioPK.nombreDetalleDominio === DominiosService.TIPO_VINCULACION_TERCERO);
        }else{
            this.consultaCargo = this.dominios.filter(dominio =>
                dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_CARGO_FUNCIONARIO);
        }
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
